import { Badge } from '@repo/ui/components/ui/badge';
import { cn } from '@repo/ui/lib/utils';
import {
  PHOTO_STATE_LABELS,
  PHOTOGRAPHER_STATE_LABELS,
  PHOTOGRAPHER_TIER_LABELS,
  type PhotoState,
  type PhotographerState,
  type PhotographerTier,
} from '@/services/photovogue';

const PHOTO_STATE_STYLES: Record<PhotoState, string> = {
  uploaded: 'bg-blue-50 text-blue-700 border-blue-200',
  ready: 'bg-violet-50 text-violet-700 border-violet-200',
  approved: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  rejected: 'bg-orange-50 text-orange-700 border-orange-200',
  banned: 'bg-red-50 text-red-700 border-red-200',
  to_fix: 'bg-amber-50 text-amber-700 border-amber-200',
};

const PHOTOGRAPHER_STATE_STYLES: Record<PhotographerState, string> = {
  valid: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'banned-temporarily': 'bg-red-50 text-red-700 border-red-200',
  'banned-permanently': 'bg-red-100 text-red-800 border-red-300',
  to_fix: 'bg-amber-50 text-amber-700 border-amber-200',
  invalid: 'bg-zinc-100 text-zinc-600 border-zinc-200',
};

export const PhotoStateBadge = ({
  state,
  className,
}: {
  state: PhotoState;
  className?: string;
}) =>
  state === 'to_fix' ? null : (
    <Badge
      variant="outline"
      className={cn('font-medium', PHOTO_STATE_STYLES[state], className)}
    >
      {PHOTO_STATE_LABELS[state]}
    </Badge>
  );

export const PhotographerStateBadge = ({
  state,
}: {
  state: PhotographerState;
}) =>
  state === 'to_fix' ? null : (
    <Badge
      variant="outline"
      className={cn('font-medium', PHOTOGRAPHER_STATE_STYLES[state])}
    >
      {PHOTOGRAPHER_STATE_LABELS[state]}
    </Badge>
  );

export const TierBadge = ({ tier }: { tier: PhotographerTier }) => (
  <Badge
    variant="outline"
    className={cn(
      'font-medium',
      tier === 'gold'
        ? 'bg-yellow-50 text-yellow-700 border-yellow-300'
        : 'bg-zinc-50 text-zinc-600 border-zinc-200',
    )}
  >
    {PHOTOGRAPHER_TIER_LABELS[tier]}
  </Badge>
);
